import React, { useEffect, useState } from 'react';
import { classNames } from 'primereact/utils';
import { Chip } from 'primereact/chip';
import { isEmpty, isNil, pathOr, uniq } from 'ramda';

// api
import LookupdataService from '../../service/lookupdata-service';

// tools
import set404FromErrorResponse from '../../helpers/set404FromErrorResponse';

// components
import ChipWithIcon from '../ChipWithIcon';

const ChipsStandalone = ({
                             fieldName,
                             label,
                             multiple = false,
                             value = multiple ? [] : 0,
                             infoText = null,
                             disabled = false,
                             isRequired = false,
                             lookupType = 'AIMED_TO',
                             onChange = () => {
                             }
                         }) => {
    const [items, setItems] = useState([]);

    const getItemsCallback = (resp) => {
        const fetchedItems = pathOr([], ['data'], resp);
        setItems(fetchedItems);
    };

    const errGetItemsCallback = (resp) => {
        set404FromErrorResponse(resp);
    };

    useEffect(() => {
        LookupdataService.getItems(getItemsCallback, errGetItemsCallback, [
            ['type', lookupType]
        ]);
    }, [lookupType]);

    const handleChangeSingle = (id) => {
        onChange(id);
    };

    const handleChangeMultiple = (id) => {
        let newValue = [];
        if (value.includes(id)) {
            newValue = value.filter(o => o !== id);
        } else {
            newValue = uniq([...value, id]);
        }
        onChange(newValue);
    }


    const input = <div className="chipInner">
        {items.map(o =>
            <Chip
                key={o.id}
                className={classNames(
                    { 'chip--selected': multiple ? value.includes(o.id) : o.id === value }
                )}
                label={o.value}
                onClick={() => disabled ? null : (multiple ? handleChangeMultiple(o.id) : handleChangeSingle(o.id))}
                template={() => <ChipWithIcon value={o.value} />}
            />
        )}
    </div>;

    return (
        <>
            <label htmlFor={fieldName} className={classNames({ 'p-error': isRequired && (isEmpty(value) || isNil(value) || value === 0)})}>
                {label}{isRequired ? <span className="appForm__field--required">*</span> : null}
            </label>
            {input}
            {infoText ? <small>{infoText}</small> : null}
        </>
    );
};

export default ChipsStandalone;